import { isValidPhoneNumber, sanitizePhoneNumber } from './util';

const validateEmail = (email) => {
  if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email))
  {
    return (true);
  }
  return (false);
};

const validateName = (name: string): boolean => {
  return /^[A-Za-z0-9 ][A-Za-z0-9 ].*$/.test(name);
};
  
const validatePhone = (phone: string): boolean => {
  return isValidPhoneNumber(phone);
};
 
const validateHttpsUrl = (url): boolean => {
  const regex = /^((https|ftp|smtp):\/\/)(www.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g;
  if(regex.test(url)){
    return true;
  } else {
    return false;
  }
};
export { validateName, validatePhone, validateEmail, validateHttpsUrl };
